import { isItemOfMessageType } from 'owa-mail-list-store';
import store from 'owa-mail-store/lib/store/Store';
/**
 * Filter the items by its isRead value
 * @param itemId the item id
 * @param isReadValue the isRead value to be set
 * @return the filtered itemIds to be updated
 */
export default function filterItemsByIsReadValue(itemIds, isReadValue) {
    var itemIdsToUpdate = [];
    itemIds.forEach(function (itemId) {
        var item = store.items.get(itemId);
        if (isItemOfMessageType(item) && item.IsRead != isReadValue) {
            itemIdsToUpdate.push(itemId);
        }
    });
    return itemIdsToUpdate;
}
//# sourceMappingURL=filterItemsByIsReadValue.js.map